import { VyhlasenievZbierkeApi } from 'elegislativa-frontend-ts-axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import Uuid from '../../model/Uuid';
import { elegislativaPrefixPath } from '../configuration/apiConfigurationConstants';
import PredpisZbierky from '../../model/legislativnyMaterial/PredpisZbierky';

const client = new VyhlasenievZbierkeApi(apiConfiguration(elegislativaPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const vyhlasenievZbierke = async (
  type: string,
  year: number,
  index: number,
  pracovnyKrokId: Uuid,
  predpisZbierkyList: Array<PredpisZbierky>,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const { status } = await client.finishPredVyhlasenimvZbierkeZakonov(
    type,
    year,
    index,
    pracovnyKrokId,
    predpisZbierkyList.map(predpisZbieky => predpisZbieky.iri),
    headers,
  );
  return {
    responseCode: status,
  };
};
